baseApp.service('ValidationService', [function($window){

    class ValidationResult {
        constructor(isValid, message) {
            this.isValid = isValid;
            this.message = message;
        }
    }



    let serviceInstance = {};

    //Input value should be string representing single ip or range, or comma-separated ips or ranges.
    //Returns true ValidationResult if input is null or empty string or representation of allow any access ip
    //Allow any access are 0.0.0.0, 0.0.0.0/0, 0.0.0.0-255.255.255.255
    serviceInstance.isAnyIpAllowed = function(value) {
        let message = 'Anyone can access this Internal IP. This is a potential security risk.';
        if(!value || value == '') {
            return new ValidationResult(true, message);;
        }
        var anyAllowedValues = ['0.0.0.0', '0.0.0.0/0', '0.0.0.0-255.255.255.255'];
        var currentValArray = value.split(',');
        currentValArray.forEach(function(ip, index, arr) {
            arr[index] = ip.replace(/\s/g, '');//remove spaces
        });
        var intersection = currentValArray.filter(x => anyAllowedValues.includes(x));
        return new ValidationResult(intersection.length > 0, message);
    };



    return serviceInstance;
}]);